import * as React from 'react';
import { Switch, Route } from 'react-router-dom';
import User from '../models/user';
import { ROUTES } from '../core/routes';
import Breadcrumbs from './breadcrumbs';

const breadcrumbRoutes = [
  ROUTES.PROGRAM_INDEX,
  ROUTES.PROGRAM_EDIT,
  ROUTES.PROGRAM_NEW,
  ROUTES.PROGRAM_REPORT,
  ROUTES.PROGRAM_SEASONS,
  ROUTES.MEMBER_INDEX,
  ROUTES.MEMBER_NEW,
  ROUTES.MEMBER,
  ROUTES.MEMBER_BACKGROUND_CHECK_NEW,
  ROUTES.STAFF_INDEX,
  ROUTES.STAFF_NEW,
  ROUTES.STAFF_EDIT,
  ROUTES.STAFF_BACKGROUND_CHECK_NEW,
  ROUTES.MESSAGE_NEW,
  ROUTES.MESSAGE_EDIT,
  ROUTES.MESSAGE_INDEX,
  ROUTES.INVOICES_INDEX,
  ROUTES.MESSAGE_SENT,
  ROUTES.SETTINGS_INDEX,
  ROUTES.REGISTRATION_INDEX,
  ROUTES.REGISTRATION_DETAILS,
  ROUTES.PARTICIPANTS_INDEX,
  ROUTES.FINANCIALS,
  ROUTES.ORDER_DETAILS,
  ROUTES.PARTICIPANT,
  ROUTES.HISTORICAL_SEASONS,
  ROUTES.SPONSORSHIPS,
  ROUTES.TOURNAMENTS,
  ROUTES.WEBSITES,
  ROUTES.COACHES_PACK,
  ROUTES.SEASON_REGISTRATIONS_INDEX,
  ROUTES.CALENDAR,
  ROUTES.SEASON_FINANCIALS,
];

export interface Props {
  user: User;
}

const BreadcrumbsWithRouter: React.FunctionComponent<Props> = ({ user }) => (
  <Switch>
    {breadcrumbRoutes.map((path) => (
      <Route exact key={path} path={path}>
        <Breadcrumbs path={path} user={user} />
      </Route>
    ))}
  </Switch>
);

export default BreadcrumbsWithRouter;
